var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--jumper", style: _vm.styles },
    [
      _c("div", { style: _vm.innerStyles }),
      _vm._v(" "),
      _c("div", { style: _vm.innerStyles }),
      _vm._v(" "),
      _c("div", { style: _vm.innerStyles }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }